// ** Redux
import { createSlice } from "@reduxjs/toolkit";

// ** Actions
import { getUserProfileFriends } from "./actions/get-user-profile-friends.action";
import { getUserProfileFollowers } from "./actions/get-user-profile-followers.action";
import { getUserProfileFollowing } from "./actions/get-user-profile-following.action";

// ############################################################

// Initial state
const initialState = {
	friends: {
		loading: false,
		loaded: false,
		success: false,
		error: false,
		total: 0,
		isPrivate: false,
		list: [],
		pagination: {
			totalPages: 0,
			currentPage: 0,
		},
	},
	followers: {
		loading: false,
		loaded: false,
		success: false,
		error: false,
		total: 0,
		isPrivate: false,
		list: [],
		pagination: {
			totalPages: 0,
			currentPage: 0,
		},
	},
	following: {
		loading: false,
		loaded: false,
		success: false,
		error: false,
		total: 0,
		isPrivate: false,
		list: [],
		pagination: {
			totalPages: 0,
			currentPage: 0,
		},
	},
};

// ############################################################

// Slice
const userProfileFriendsSlice = createSlice({
	name: "user-profile/friends",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getUserProfileFriends.pending, (state) => {
			state.friends.loading = true;
			state.friends.error = false;
			state.friends.loaded = false;
			state.friends.total = 0;
			state.friends.isPrivate = false;
		});
		builder.addCase(getUserProfileFriends.fulfilled, (state, action) => {
			state.friends.loading = false;
			state.friends.error = false;
			state.friends.loaded = true;
			const newDataFriends = action.payload.infinityScroll
				? [...state.friends.list, ...(action.payload.users ?? [])]
				: action.payload.users ?? [];
			state.friends.total = action.payload.total ?? 0;
			state.friends.isPrivate = !action.payload.privacy;
			state.friends.list = action.infinityScroll
				? newDataFriends.filter((val, id) => {
						return (
							id ===
							newDataFriends.findIndex((el) => el.id === val.id)
						);
				  })
				: newDataFriends;
			state.friends.pagination = {
				totalPages: action.payload.pagination.totalpages ?? 1,
				currentPage: action.payload.pagination.currentpage ?? 1,
			};
		});
		builder.addCase(getUserProfileFriends.rejected, (state) => {
			state.friends.loading = false;
			state.friends.error = true;
			state.friends.loaded = true;
			state.friends.total = 0;
		});
		builder.addCase(getUserProfileFollowers.pending, (state) => {
			state.followers.loading = true;
			state.followers.error = false;
			state.followers.loaded = false;
			state.followers.total = 0;
			state.followers.isPrivate = false;
		});
		builder.addCase(getUserProfileFollowers.fulfilled, (state, action) => {
			state.followers.loading = false;
			state.followers.error = false;
			state.followers.loaded = true;

			const newDataFriendsFollowers = action.payload.infinityScroll
				? [...state.followers.list, ...(action.payload.users ?? [])]
				: action.payload.users ?? [];

			state.followers.total = action.payload.total ?? 0;
			state.followers.list = action.payload.infinityScroll
				? newDataFriendsFollowers.filter((val, id) => {
						return (
							id ===
							newDataFriendsFollowers.findIndex(
								(el) => el.id === val.id
							)
						);
				  })
				: newDataFriendsFollowers;
			state.followers.pagination = {
				totalPages: action.payload.pagination.totalpages ?? 1,
				currentPage: action.payload.pagination.currentpage ?? 1,
			};
		});
		builder.addCase(getUserProfileFollowers.rejected, (state) => {
			state.followers.loading = false;
			state.followers.error = true;
			state.followers.loaded = true;
		});
		builder.addCase(getUserProfileFollowing.pending, (state) => {
			state.following.loading = true;
			state.following.error = false;
			state.following.loaded = false;
			state.following.total = 0;
			state.following.isPrivate = false;
		});
		builder.addCase(getUserProfileFollowing.fulfilled, (state, action) => {
			state.following.loading = false;
			state.following.error = false;
			state.following.loaded = true;

			const newDataFriendsFollowing = action.payload.infinityScroll
				? [...state.following.list, ...(action.payload.users ?? [])]
				: action.payload.users ?? [];

			state.following.total = action.payload.total ?? 0;
			state.following.isPrivate = !action.payload.privacy;
			state.following.list = action.payload.infinityScroll
				? newDataFriendsFollowing.filter((val, id) => {
						return (
							id ===
							newDataFriendsFollowing.findIndex(
								(el) => el.id === val.id
							)
						);
				  })
				: newDataFriendsFollowing;
			state.following.pagination = {
				totalPages: action.payload.pagination.totalpages ?? 1,
				currentPage: action.payload.pagination.currentpage ?? 1,
			};
		});
		builder.addCase(getUserProfileFollowing.rejected, (state) => {
			state.following.loading = false;
			state.following.error = true;
			state.following.loaded = true;
		});
	},
});

// ############################################################

export default userProfileFriendsSlice.reducer;

// ############################################################
